import list from "./list";
import listNoCa from "./listNoCa";

export default {
  namespaced: true,
  modules: {
    list,
    listNoCa,
  },
};
